<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="
        $browserDetect && $browserDetect.isFirefox ? true : false
      "
      :preview-modal="false"
      :filename="
        'Company Profile - ' +
          (this.$route.path.includes('sample')
            ? 'sample'
            : this.$route.params.id)
      "
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1150px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)"
      @hasGenerated="afterDownload($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content" class="pdf_docs prfl-pdf">
        <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div class="banner page">
            <div class="section_body">
              <img src="/img/pdf_logo.png" alt="" class="company_logo" />
              <h1>Company Profile</h1>

              <h6>{{ headerInfo.headerData.industry }}</h6>
              <ul>
                <li>
                  Market Area:
                  <span>
                    {{
                      headerInfo.user && headerInfo.user.personalize
                        ? headerInfo.user.personalize.area
                        : ""
                    }}</span
                  >
                </li>
              </ul>
            </div>
            <div class="banner_footer">
              <!-- <h6>American Author</h6>-->
              <span class="author"><!--Joyce Meyer--> </span>
              <!-- <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>-->
            </div>
          </div>
        </section>

        <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div class="company_info abut-list bg-grey page">
            <div class="section_body">
              <ul class="blue-crcl">
                <li>
                  <p>About the Data</p>
                  <p>Data Sources and Limitations</p>
                  <span class="grn-color">1</span>
                </li>
                <li>
                  <h5>Company Profile</h5>
                  <!-- <p>Mr & MRS Furniture & More Tazewell Floor Covering Inc Amish Choice Wood Furniture Loris Kitchen Store</p>
                <span class="grn-color">2</span> -->
                </li>
                <li>
                  <h5>Extra Information</h5>
                  <p>
                    Profitability <br />Sales <br />Efficiency <br />Market
                    Opportunity and Saturation <br />Cash Flow <br />Debt Risk
                  </p>
                  <span class="grn-color">3</span>
                </li>
                <li>
                  <h5>Insights</h5>
                  <p>
                    Average Annual Sales ($) Sep-2021 Average Annual Sales ($)
                    Competitive Market Narrative
                  </p>
                  <span class="grn-color">4</span>
                </li>
                <li>
                  <h5>Covid-19 Impact</h5>
                  <p>
                    Month-to-Month Employment-Sales % Change from Dec-19 Monthly
                    Change Index (Dec-19=1.00)
                  </p>
                  <span class="grn-color">5</span>
                </li>
                <li>
                  <h5>Company Terms</h5>
                  <p>
                    Market Penetration ($) Sep-2021 Market Penetration ($)
                    Competitive Market Narrative
                  </p>
                  <span class="grn-color">6</span>
                </li>
              </ul>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div class="about_info page">
            <div class="section_body">
              <div class="about_list">
                <h2 class="blue-text">About the Data</h2>
                <h4 class="blue-grdnt">
                  {{ moment(new Date()).format("MMM Do YYYY") }}
                </h4>
              </div>
              <div class="negetive_margin">
                <div class="md-layout mt-2 mb-2">
                  <div class="md-layout-item md-size-50">
                    <div class="blue-box">
                      <span>Bizminer</span> data is widely accepted for industry
                      analytical work, benchmarking, valuations, forensics and
                      litigation. Raw data analyzed for Bizminer reports is
                      sourced from an array of the nation's government and
                      private statistical sources. None of these raw data
                      sources creates the final measures reflected in Bizminer
                      industry profiles. In total, Bizminer accesses over a
                      billion sourced data points from 15 million business
                      operations for each of its twice annual updates covering a
                      3-5 year time series. Historical data and Bizminer
                      algorithms are used to inform and test projections for
                      non-reporting firms. Data elements are sourced
                      specifically from:
                    </div>
                  </div>
                  <div class="md-layout-item md-size-50 info-text">
                    <p>
                      Raw data analyzed for Bizminer reports is sourced from an
                      array of the nation's government and private statistical
                      sources. None of these raw data sources creates the final
                      measures reflected in Bizminer industry profiles. In
                      total, Bizminer accesses over a billion sourced data
                      points from 15 million business operations for each of its
                      twice annual updates covering a 3-5 year time series.
                      Historical data and Bizminer algorithms are used to inform
                      and test projections for non-reporting firms. Data
                      elements are sourced specifically from:
                    </p>

                    <p>
                      While 100% firm coverage is desirable for analysis
                      purposes, the greatest value of Bizminer reports rests in
                      discerning patterns of activity, which are reflected in
                      the large samples used to develop our reports. The overall
                      current coverage of the databases surpasses 13 million
                      active business operations at any point in time. As is the
                      case with any databases this large, some errors are
                      inevitable. Some firms are missed and specific information
                      on others is lacking from the database. Not all
                      information received is uniform or complete, resulting in
                      the need to develop projection algorithms for specific
                      industry segments and metrics in some report series. No
                      representation is made as to the accuracy of the databases
                      utilized or the results of subsequent analyses.
                    </p>
                  </div>
                </div>
              </div>
              <div class="list_box purple-tick">
                <ul>
                  <li>IRS Statistics of Income</li>
                  <li>IRS SOI Corporation Tax Book</li>
                  <li>IRS Sole Proprietorship Tables</li>
                  <li>US Economic Census</li>
                  <li>US Census Quarterly Financial Reports</li>
                  <li>US Census County Business Patterns</li>
                  <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                  <li>
                    Bureau of Labor Statistics Monthly Unemployment Reports
                  </li>
                  <li>Bureau of Labor Statistics Annual Wage Survey</li>
                  <li>
                    Bureau of Labor Statistics Industry Productivity Reports
                  </li>
                  <li>Bureau of Labor Statistics Price Indices</li>
                  <li>Bureau of Labor Statistics Consumer Price Index</li>
                  <li>National Agricultural Statistical Service</li>
                  <li>US Census Retail Trade Report</li>
                  <li>Data Axle</li>
                  <li>Business Valuation Resources (BVR)</li>
                  <li>American Community Survey</li>
                </ul>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div class="company_profile page">
            <div class="section_body">
              <div class="section_title">
                <h2>Company Profile</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
              <div
                v-if="profileInfo !== null"
                class="details"
                md-alignment="left"
              >
                <span v-if="profileInfo.companyTitle" class="md-subheading">{{
                  profileInfo.companyTitle
                }}</span>
                <div>
                  {{ profileInfo.address ? profileInfo.address : "" }}
                  <b v-if="profileInfo.businessOwner">Contact: </b>
                  {{ profileInfo.businessOwner ? profileInfo.businessOwner : ""
                  }}<br profileInfo.businessOwner />
                  <b v-if="profileInfo.phone">Phone: </b>
                  {{ `${profileInfo.phone}` }}<br v-if="profileInfo.phone" />
                  <b v-if="profileInfo.businessURL">URL: </b
                  >{{ profileInfo.businessURL ? profileInfo.businessURL : "" }}
                  <br v-if="profileInfo.businessURL" />
                </div>
                <div>
                  <b v-if="profileInfo.email">Mailing Address: </b
                  >{{ profileInfo.email ? profileInfo.email : ""
                  }}<br v-if="profileInfo.email" />
                </div>
                <div>
                  <b v-if="profileInfo.naics">Industry: </b
                  >{{ `[${profileInfo.naics}] ${profileInfo.industry}` }}
                </div>
              </div>
              <div class="extra_info">
                <div class="flex_item">
                  <h3><md-icon>cases</md-icon>Business Directory Industries</h3>
                  <ul class="directory">
                    <li v-for="item in industries" :key="item.id">
                      <ul>
                        <li v-if="item['labels.sic_code_id']">
                          {{ item["labels.sic_code_id"]
                          }}<span>SIC Code Label</span>
                        </li>
                        <li v-if="item['labels.yellow_page_code']">
                          {{ item["labels.yellow_page_code"]
                          }}<span>Yellow Page label</span>
                        </li>
                        <li v-if="item['sic_code_id']">
                          {{ item["sic_code_id"] }}<span>SIC Code</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div class="flex_item">
                  <h3><md-icon>tap_and_play</md-icon>Connect With Us</h3>
                  <ul>
                    <li>
                      <div v-for="item in socials" :key="item" class="social">
                        <a :href="item.url" target="_blank">
                          <i :class="item.icon"></i>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div v-if="operatingHours && operatingHours.start_time">
                        <p>
                          <b>{{ operatingHours["labels.days"] }}</b>
                          <br />
                          <b>
                            {{ operatingHours["start_time"] }}
                            to
                            {{ operatingHours["end_time"] }}
                          </b>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="md-card-content" md-alignment="left">
                <!--    <google-map-loader
                  v-if="!setLoading"
                  ref="mapRef"
                  :locations="location"
                  :center="mapCenter"
                  />-->
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <template v-for="(itemContacts, index) in contactsChunk">
          <section :ref="'contactsChunk' + index"  :key="'contact-chunk-' + index" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="company_profile page">
              <div class="section_body">
              
                <div class="extra_info">
                  <div class="flex_item">
                    <h3><md-icon>people_alt</md-icon>People</h3>
                    <ul>
                      <li v-for="item in itemContacts" :key="'contact-item-chunk'+item.id">
                        <img src="/img/placeholder.png" alt="Avatar user" />
                        <h5>
                          {{ item.first_name }} {{ item.last_name }}
                          <span>{{ item["labels.title_codes"] }}</span>
                        </h5>
                      </li>
                    </ul>
                  </div>               
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
        </template>
       
        <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div class="value_multiples">
            <div class="table_sec">
              <IFInsightspdf />
            </div>
          </div>
        </section>

        <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div class="value_multiples">
            <div class="table_sec">
              <IndustryCovidpdf />
            </div>
          </div>
        </section>

        <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div class="terms">
            <div class="table_sec">
              <div class="md-layout-item md-size-100 page">
                <div class="section_body">
                  <div class="section_title">
                    <h2>Terms</h2>
                    <span class="date">{{
                      moment(new Date()).format("MMM Do YYYY")
                    }}</span>
                  </div>
                  <div class="md-layout mt-4 mb-4">
                    <div class="md-layout-item md-size-100 terms_header">
                      Industry Financial Insight Terms
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>
                        Industry peer group percentage averages are applied to
                        the company's estimatedrevenue.
                      </h6>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Gross Margin:</h6>
                      <p>Business Revenue minus Cost of Sales</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Officer/Owner's Compensation:</h6>
                      <p>
                        Total wage compensation for services of company officers
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Depreciation:</h6>
                      <p>
                        Current portion of non-cash
                        depreciation-amortization-depletion
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Operating Expenses:</h6>
                      <p>
                        Discretionary Expenses (excludes Cost of Sales and
                        Interest Paid)
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>After-Tax Net Profit:</h6>
                      <p>Net Profit after payment of income taxes</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Owner Earnings:</h6>
                      <p>Officers Compensation+Net Profit+Depreciation</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Net Worth/Assets:</h6>
                      <p>Net Worth as a percent of Total Assets</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Accounts Receivable: Total Assets:</h6>
                      <p>Short-term receivables as a percent of Total Assets</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Accounts Payable:TL& NW:</h6>
                      <p>
                        Short-term receivables as a percent of Total
                        Liabilities+Net Worth
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Days Payable:</h6>
                      <p>365/(Cost of Sales/Accounts Payable ratio)</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Days Receivable:</h6>
                      <p>365/(Business Revenue/Receivables)</p>
                    </div>

                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Current Ratio:</h6>
                      <p>Current Assets/Current Liabilities</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Interest Coverage:</h6>
                      <p>
                        [Earnings before Interest, Taxes Due,
                        DepreciationAmortization]/Interest expense
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Current Liabilities:</h6>
                      <p>Net Worth: Current Liabilities/Net Worth</p>
                    </div>
                  </div>
                  <p class="common_footer p-0">
                    Copyright © 2022 Bizminer. All Rights Reserved.
                  </p>
                </div>
              </div>

              <div class="md-layout-item md-size-100 page">
                <div class="section_body">
                  <div class="md-layout mt-4 mb-4">
                    <div class="md-layout-item md-size-100 terms_header">
                      Industry Financial Insight Terms
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Total Liabilities: Net Worth:</h6>
                      <p>Total liabilities/Net Worth</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Modified Z-Score:</h6>
                      <p>
                        A modified form of the Altman Z-Score which evaluates
                        default risk
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Net Working Capital: Revenue:</h6>
                      <p>
                        (Current Assets-Current Liabilities)/Business Revenue
                      </p>
                    </div>

                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Accounts Payable:Revenue:</h6>
                      <p>Accounts Payable/Business Revenue</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Loans-Notes Payable:Net Worth:</h6>
                      <p>Loans-Notes Payable/Net Worth</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Owner Earnings (Cash Flow) Approach:</h6>
                      <p>Revenue/Owner Earnings market valuation approach</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>
                        Bizminer Valuations basis derived from projected company
                        sales; peer group average earnings %; and industry
                        valuation multiples. Median ranges reflect a range of
                        market conditions and business performance at this
                        revenue scale.
                      </h6>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>
                        You should not use Bizminer Valuations in place of a
                        professional valuation or as the basis of any specific
                        business-related or other financial transaction; nor to
                        secure a business or personal loan.
                      </h6>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Sales Approach:</h6>
                      <p>Revenue/Annual Sales market value approach</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Median and Quartiles: Median:</h6>
                      <p>
                        the point at which 50% of a sample is above and 50% of
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>the same below the value.</h6>
                      <p>between the median and the highest value</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>
                        Quartile 1 lies at the mid-point between the median and
                        the lowest value; Quartile 3
                      </h6>
                    </div>
                  </div>
                  <p class="common_footer p-0">
                    Copyright © 2022 Bizminer. All Rights Reserved.
                  </p>
                </div>
              </div>

              <div class="md-layout-item md-size-100 page">
                <div class="section_body">
                  <div class="md-layout mt-4 mb-4">
                    <div class="md-layout-item md-size-100 terms_header">
                      Industry Analysis Insight Terms
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Market Area:</h6>
                      <p>
                        The selected market parameters for this industry. Where
                        there are at least five identified industry
                        establishments, default market parameters are:
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>15 mile radius</h6>
                      <p>
                        44-45 Retail Trade
                        <br />72 Accommodation-Food Services <br />811-812 Other
                        Services
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Metro</h6>
                      <p>
                        23 Construction
                        <br />42 Wholesale Trade <br />48-49
                        Transportation-Warehousing <br />51 Information <br />52
                        Finance and Insurance <br />53 Real Estate- Rental and
                        Leasing <br />54 Professional-Scientific-Technical
                        Services <br />56
                        Administrative-Support-Waste-Remediation <br />61
                        Educational Services <br />62 Health Care-Social
                        Assistance <br />71 Arts-Entertainment- Recreation
                        <br />813 Religious-Grantmaking-Civic-Professional and
                        Similar Organizations
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Us-national</h6>
                      <p>
                        11 Agriculture-Forestry-Fishing-Hunting
                        <br />21 Mining-Quarrying- Oil &amp; Gas Extraction
                        <br />22 Utilities <br />31-32-33 Manufacturing <br />55
                        Management- Companies &amp; Enterprises
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Industry Map:</h6>
                      <p>
                        Displays the closest operations in the same industry as
                        the selected firm
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Competitors:</h6>
                      <p>
                        The number of same-industry operations within the market
                        area.
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Industry Market Sales Volume:</h6>
                      <p>Aggregate industry market sales</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Average Site Sales:</h6>
                      <p>
                        Average annual revenue of industry market operations in
                        the market area.
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Average Small Business Sales:</h6>
                      <p>
                        Average annual sales of single site firms with
                        25employees in the market
                      </p>
                    </div>
                  </div>
                  <p class="common_footer p-0">
                    Copyright © 2022 Bizminer. All Rights Reserved.
                  </p>
                </div>
              </div>

              <div class="md-layout-item md-size-100 page">
                <div class="section_body">
                  <div class="md-layout mt-4 mb-4">
                    <div class="md-layout-item md-size-100 terms_header">
                      Industry Analysis Insight Terms
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Firm Sales Rank:</h6>
                      <p>
                        Sales rank based on this location's estimated revenue
                        among all sameindustry market operations
                      </p>
                    </div>

                    <div class="md-layout-item md-size-33 box_data">
                      <h6>US and Market Sales per Household:</h6>
                      <p>
                        Sales per household using the US as a comparisonbasis
                        for the local market or, if a national market,
                        displaying that value.
                      </p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Per Capita Income:</h6>
                      <p>Average area income per person</p>
                      <h6>Median Household Income:</h6>
                      <p>Median (mid-point) area income per household</p>
                    </div>
                    <div class="md-layout-item md-size-33 box_data">
                      <h6>Median Household Income:</h6>
                      <p>Median (mid-point) area income per household</p>
                    </div>
                  </div>
                  <p class="common_footer p-0">
                    Copyright © 2022 Bizminer. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
// import GoogleMapLoader from '@/pages/Dashboard/Components/GoogleMapLoader';
import VueHtml2pdf from "vue-html2pdf";
import { mapState } from "vuex";
import IFInsightspdf from "./IFInsightspdf.vue";
import IndustryCovidpdf from "./IndustryCovidpdf.vue";
import moment from "moment";
export default {
  name: "PdfDocument",
  components: {
    //GoogleMapLoader,
    VueHtml2pdf,
    IndustryCovidpdf,
    IFInsightspdf,
  },
  data() {
    return {
      contactsChunk: [],
      moment: moment,
    };
  },
  props: ["headerInfo"],
  mounted() {
    if (this.contacts) {
      this.contactsChunk =this.contacts         
          .chunk(40);
    }
  },
  methods: {
    numberWithPoints(x) {
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else if (x === null) {
        return x;
      } else {
        return x.replace(/,/g, ".");
      }
    },
    downloadCSVData() {
      let csv = "";
      this.getCsvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Company Profile.csv";
      anchor.click();
    },

    reverseArray(a) {
      var rA = [];
      for (var i = a.length; i > 0; i--) {
        rA.push(a[i - 1]);
      }

      return rA;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress($e) {},
    async beforeDownload({ html2pdf, options, pdfContent }) {
      // this.convertImages();

      this.$store.commit("user/SET_PDF_LOADING", true);

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      
      let page5 = this.$refs.page5;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;

      let pages = [page1, page2, page3, page4];

      
      this.contactsChunk.forEach((dem, index) => {
                    if (this.$refs['contactsChunk' + index]) {
                        pages.push(this.$refs['contactsChunk' + index][0]);
                    }
                });
      
      pages.push(page5, page6, page7);
      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();

      pages.slice(1).forEach(function(page) {
        worker = worker
          .get("pdf")
          .then(function(pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });


      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.$store.commit("user/SET_PDF_LOADING", false);
    },
    filterNode(node) {
      if (node instanceof Text) {
        return true;
      }
      return (
        [
          "div",
          "span",
          "p",
          "i",
          "strong",
          "main",
          "aside",
          "article",
          "pre",
          "code",
          "time",
          "address",
          "header",
          "footer",
        ].includes(node.tagName.toLowerCase()) ||
        /^h[123456]$/i.test(node.tagName)
      );
    },
    convertImages() {},
  },
  computed: {
    /*  ...mapState({
      user: (state) => state.user.user,
    }),*/
    user() {
      return this.$store.state.user.user;
    },
    ifInfo() {
      return this.$store.getters.profileInfo;
    },
    socials() {
      let socials = [];
      let details =
        this.ifInfo && this.ifInfo.fine_details
          ? this.ifInfo.fine_details.socials
          : "";

      if (details.facebook)
        socials.push({
          name: "Facebook",
          url: details.facebook,
          icon: "fab fa-facebook",
        });
      if (details.foursquare)
        socials.push({
          name: "FourSquare",
          url: details.foursquare,
          icon: "fab fa-foursquare",
        });
      if (details.instagram)
        socials.push({
          name: "Instagram",
          url: details.instagram,
          icon: "fab fa-instagram",
        });
      if (details.linked_in)
        socials.push({
          name: "LinkedIn",
          url: details.linked_in,
          icon: "fab fa-linkedin",
        });
      if (details.pinterest)
        socials.push({
          name: "Pinterest",
          url: details.pinterest,
          icon: "fab fa-pinterest",
        });
      if (details.tumblr)
        socials.push({
          name: "Tumblr",
          url: details.tumblr,
          icon: "fab fa-tumblr",
        });
      if (details.twitter)
        socials.push({
          name: "Twitter",
          url: details.twitter,
          icon: "fab fa-twitter",
        });
      if (details.yelp)
        socials.push({ name: "Yelp", url: details.yelp, icon: "fab fa-yelp" });
      if (details.youtube)
        socials.push({
          name: "YouTube",
          url: details.youtube,
          icon: "fab fa-youtube",
        });

      return socials;
    },

    companyLogo() {
      let companyLogo = "";
      if (this.ifInfo && this.ifInfo.fine_details) {
        companyLogo = this.ifInfo.fine_details.logo;
      }
      return companyLogo;
    },
    contacts() {
      let contacts = [];
      if (this.ifInfo && this.ifInfo.fine_details) {
        contacts = this.ifInfo.fine_details.contacts;
      }
      return contacts;
    },
    operatingHours() {
      return this.ifInfo && this.ifInfo.fine_details.hours
        ? this.ifInfo.fine_details.hours[0]
        : {};
    },
    industries() {
      return this.ifInfo && this.ifInfo.fine_details
        ? this.ifInfo.fine_details.industry
        : "";
    },
    profileInfo() {
      return this.$store.getters.profileInfo;
    },
    releaseDate() {
      return this.$store.getters.releaseDate;
    },
    location() {
      return [
        {
          CONAME: this.profileInfo.companyTitle,
          lat: this.profileInfo.latlon.lat,
          lng: this.profileInfo.latlon.lon,
        },
      ];
    },
    mapCenter() {
      return this.profileInfo
        ? { lat: this.profileInfo.latlon.lat, lon: this.profileInfo.latlon.lon }
        : null;
    },
    getFormattedData() {
      let a = {};

      a.company = this.profileInfo.companyTitle;
      a.original_name = "";
      a.infogroup = this.profileInfo.locnum;
      a.unique_id = "";
      a.street = this.profileInfo.street ? this.profileInfo.street : "";
      a.city = this.profileInfo.city ? this.profileInfo.city : "";
      a.state = this.profileInfo.state ? this.profileInfo.state : "";
      a.zip = this.profileInfo.zip ? this.profileInfo.zip : "";
      a.industry_code = this.profileInfo.naics;
      a.industry = this.profileInfo.industry;

      let b = this.profileInfo.businessOwner
        ? this.profileInfo.businessOwner.split(",")[0]
        : "";
      a.contact_first = b.split(" ")[0];
      a.contact_last = b.split(" ")[1];
      a.phone = this.profileInfo.businessPhone
        ? this.profileInfo.businessPhone
        : "";
      a.url = this.profileInfo.businessURL ? this.profileInfo.businessURL : "";
      let g = this.profileInfo.release_id.replace("_", "-01-20");
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      a.operation_details =
        monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.location_annual_sales = this.profileInfo.bizop["Location Sales"][0];
      a.location_employment = this.profileInfo.bizop["Employment"][0];
      a.corporation_annual_sales = this.profileInfo.bizop["Corporate Sales"][0];
      a.corporation_employment = this.profileInfo.bizop[
        "Corporate Employment"
      ][0];

      a.market_insights_date =
        monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.market_industry_code = this.profileInfo.IMRnaics;
      a.market_industry = this.profileInfo.IMRindustry;
      a.market_area = this.profileInfo["MR"]["area"];

      a.industry_operations = this.profileInfo["MR"]["main"][
        "Industry Operations"
      ];
      a.location_sales_rank = this.profileInfo["MR"]["main"][
        "Business Sales Rank"
      ];
      a.industry_market_sales_volume = this.profileInfo["MR"]["main"][
        "Annual Market Sales Volume"
      ];
      a.average_site_sales = this.profileInfo["MR"]["main"][
        "Average Site Sales"
      ];
      a.average_small_business_sales = this.profileInfo["MR"]["main"][
        "Average Small Business Sales"
      ];

      a.industry_market_sales_per_person = this.profileInfo["MR"][
        "penetration"
      ]["Market Sales per Person"];
      a.us_industry_sales_per_person = this.profileInfo["MR"]["penetration"][
        "US Sales per Person"
      ];
      a.opportunity_index_person = this.profileInfo["MR"]["penetration"][
        "Opportunity Index Person"
      ];
      a.industry_market_sales_per_household = this.profileInfo["MR"][
        "penetration"
      ]["Market Sales per Household"];
      a.us_industry_sales_per_household = this.profileInfo["MR"]["penetration"][
        "US Sales per Household"
      ];
      a.opportunity_index_household = this.profileInfo["MR"]["penetration"][
        "Opportunity Index Household"
      ];

      a.market_area_population = this.profileInfo["MR"]["income"]["Population"];
      a.market_area_households = this.profileInfo["MR"]["income"]["Households"];
      a.per_capita_income = this.profileInfo["MR"]["income"][
        "Per Capita Income"
      ];
      a.mediab_hh__income = this.profileInfo["MR"]["income"][
        "Median HH Income"
      ];
      a.business_values_insights_date =
        monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();

      a.sales_approach_quartile1 = this.profileInfo.multiples.data[
        "Quartile 1"
      ]["sales"];
      a.sales_approach_median = this.profileInfo.multiples.data["Median"][
        "sales"
      ];
      a.sales_approach_quartile3 = this.profileInfo.multiples.data[
        "Quartile 3"
      ]["sales"];
      a.earnings_approach_quartile1 = this.profileInfo.multiples.data[
        "Quartile 1"
      ]["earnings"];
      a.earnings_approach_median = this.profileInfo.multiples.data["Median"][
        "earnings"
      ];
      a.earnings_approach_quartile3 = this.profileInfo.multiples.data[
        "Quartile 3"
      ]["earnings"];

      a.if_industry_code = this.profileInfo.naics;
      a.if_industry_name = this.profileInfo.industry;
      a.if_industry_sales_class = this.profileInfo.IF["sales-class"];
      a.financial_insights_date = this.profileInfo.IF["period"];

      a.gross_margin_percentage = this.profileInfo.IF.spend[
        "Gross Margin"
      ].percentage;
      a.office_owner_compensation_percentage = this.profileInfo.IF.spend[
        "Officer-Owner-Compensation"
      ].percentage;
      a.depreciation_percentage = this.profileInfo.IF.spend[
        "Depreciation"
      ].percentage;
      a.operating_expense_percentage = this.profileInfo.IF.spend[
        "Operating Expenses"
      ].percentage;
      a.operating_income_percentage = this.profileInfo.IF.spend[
        "Operating Income"
      ].percentage;
      a.after_tax_net_profit_percentage = this.profileInfo.IF.spend[
        "After Tax Net Profit"
      ].percentage;
      a.owner_earnings_percentage = this.profileInfo.IF.spend[
        "Owner Earnings"
      ].percentage;
      a.account_receivable_percentage = this.profileInfo.IF.spend[
        "Accounts Receivable: Total Assets"
      ].percentage;
      a.account_payable_percentage = this.profileInfo.IF.spend[
        "Accounts Payable: TLNW"
      ].percentage;
      a.net_worth_assets_percentage = this.profileInfo.IF.spend[
        "Net Worth: Assets"
      ].percentage;

      a.gross_margin_dollar = this.profileInfo.IF.spend["Gross Margin"].dollar;
      a.office_owner_compensation_dollar = this.profileInfo.IF.spend[
        "Officer-Owner-Compensation"
      ].dollar;
      a.depreciation_dollar = this.profileInfo.IF.spend["Depreciation"].dollar;
      a.operating_expense_dollar = this.profileInfo.IF.spend[
        "Operating Expenses"
      ].dollar;
      a.operating_income_dollar = this.profileInfo.IF.spend[
        "Operating Income"
      ].dollar;
      a.after_tax_net_profit_dollar = this.profileInfo.IF.spend[
        "After Tax Net Profit"
      ].dollar;
      a.owner_earnings_dollar = this.profileInfo.IF.spend[
        "Owner Earnings"
      ].dollar;
      a.account_receivable_dollar = this.profileInfo.IF.spend[
        "Accounts Receivable: Total Assets"
      ].dollar;
      a.account_payable_dollar = this.profileInfo.IF.spend[
        "Accounts Payable: TLNW"
      ].dollar;
      a.net_worth_assets_dollar = this.profileInfo.IF.spend[
        "Net Worth: Assets"
      ].dollar;

      a.account_payable_revenue = this.profileInfo.IF.benchmarks[
        "Accounts Payable: Revenue"
      ];
      a.current_ratio = this.profileInfo.IF.benchmarks["Current Ratio"];
      a.days_payable = this.profileInfo.IF.benchmarks["Days Payable"];
      a.net_working_capital_revenue = this.profileInfo.IF.benchmarks[
        "Net Working Capital Revenue"
      ];
      a.days_receivable = this.profileInfo.IF.benchmarks["Days Receivable"];
      a.interest_coverage = this.profileInfo.IF.benchmarks["Interest Coverage"];
      a.current_liabilites = this.profileInfo.IF.benchmarks[
        "Current Liabilities: NW"
      ];
      a.loans_notes = this.profileInfo.IF.benchmarks[
        "Loans‐Notes Payable: Net Worth"
      ];
      a.modified_z = this.profileInfo.IF.benchmarks["Modified Z Score"];
      a.total_liabilities = this.profileInfo.IF.benchmarks[
        "Total Liabilties: Net Worth"
      ];

      Object.values(a).forEach((element, index) => {
        let b = "";
        if (element && element.includes(",")) {
          b = element.replace(/,/g, ".");
        } else {
          b = element;
        }
        this.filtered_company_profile_list.push(b);
      });
      return this.filtered_company_profile_list;
    },
    getCsvData() {
      let csvData = [
        [
          "Company",
          "Original Name",
          "Infogroup ID",
          "Unique ID",
          "Street",
          "City",
          "State",
          "Zip",
          "Industry Code",
          "Industry",
          "Contact First",
          "Contact Last",
          "Phone",
          "URL",
          "Operation Detail Release",
          "Location Annual Sales",
          "Location Employment",
          "Corporate Annual Sales",
          "Corporate Employment",
          "Market Insights Date",
          "Market Industry Code",
          "Market Industry",
          "Market Area",
          "Industry Operations",
          "Location Sales Rank",
          "Industry Market Sales Volume",
          "Average Site Sales",
          "Average Small Business Sales",
          "Industry Market Sales per Person",
          "US Industry Sales per Person",
          "Opportunity Index",
          "Industry Market Sales per Household",
          "US Industry Sales per Household",
          "Opportunity Index",
          "Market Area Population",
          "Market Area Households",
          "Per Capital Income",
          "Median Household Income",
          "Business Value Insights Date",
          "Sales Approach Quartile1",
          "Sales Approach Median",
          "Sales Approach Quartile3",
          "Earnings Approach Quartile1",
          "Earnings Approach Median",
          "Earnings Approach Quartile3",
          "IF Industry code",
          "IF Industry name",
          "IF Sales class",
          "Financial Insights Date",
          "Gross Margin %",
          "Officer-Owner Compensation %",
          "Depreciation %",
          "Operating Expense %",
          "Operating Income %",
          "After Tax Net Profit %",
          "Owner Earnings %",
          "Accounts Receivable/Total Assets %",
          "Accounts Payable/TLNW %",
          "Net Worth/Assets %",
          "Gross Margin $",
          "Officer-Owner Compensation $",
          "Depreciation $",
          "Operating Expense $",
          "Operating Income $",
          "After Tax Net Profit $",
          "Owner Earnings $",
          "Accounts Receivable/Total Assets $",
          "Accounts Payable/TLNW $",
          "Net Worth/Assets $",
          "Accounts Payable/Revenue",
          "Current Ratio",
          "Days Payable",
          "Net Working Capital/Revenue",
          "Days Receivable",
          "Interest Coverage",
          "Current Liabilities/Net Worth",
          "Loans Notes Payable/Net Worth",
          "Modified Z Score",
          "Total Liabilties/Net Worth",
        ],
      ];
      csvData.push(this.getFormattedData);
      return csvData;
    },
    setLoading() {
      return !this.profileInfo;
    },

    pdfDownloadSetting() {
      //alert(this.user.preferences.defaultPDFDownload)
      //alert("test");
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
  },
};
</script>
